import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '../../../atoms'
import {
  EmptyState,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription,
} from './FilesEmptyState.styles'
import type { FilesEmptyStateProps } from './FilesEmptyState.types'

export const FilesEmptyState: React.FC<FilesEmptyStateProps> = ({
  title,
  description,
  iconName = 'document',
}) => {
  const { t } = useTranslation('ui')

  const displayTitle = title ?? t('files.emptyTitle')
  const displayDescription = description ?? t('files.emptyDescription')

  return (
    <EmptyState>
      <EmptyIcon>
        <Icon name={iconName as any} size="large" />
      </EmptyIcon>
      <EmptyTitle>{displayTitle}</EmptyTitle>
      <EmptyDescription>{displayDescription}</EmptyDescription>
    </EmptyState>
  )
}
